import {createAuthHeader, RestClient} from '../../rest-client';

export class MBIDAuthService {
  private client: RestClient;

  constructor(client: RestClient) {
    this.client = client;
  }

  authenticate = (url?: string, request?: AuthenticateRequest) => {
    return this.client.fetchJSONBody<MBIDAuthenticateResponse>(
      'POST',
      url,
      request,
      createAuthHeader(request?.token),
    );
  };

  revokeToken = (url: string | undefined, token?: string) => {
    return this.client.fetchJSON(
      'POST',
      url,
      undefined,
      createAuthHeader(token),
    );
  };

  subscribe = async (url: string, token: string) => {
    return this.client.fetchJSON(
      'GET',
      url,
      undefined,
      createAuthHeader(token),
    );
  };

  refreshLogin = (url: string | undefined, token: string | undefined) => () => {
    return this.client.fetchJSON(
      'GET',
      url,
      undefined,
      createAuthHeader(token),
    );
  };

  signTNC = (url?: string, token?: string) => {
    return this.client.fetchJSONBody<MBIDAuthCompleteResponse>(
      'POST',
      url,
      undefined,
      createAuthHeader(token),
    );
  };

  contactDetails = async (url?: string, token?: string) => {
    return this.client.fetchJSON(
      'GET',
      url,
      undefined,
      createAuthHeader(token),
    );
  };
}

export interface AuthenticateRequest {
  token: string;
  endUserIp?: string;
  governmentId?: string;
  authBE?: string;
}

export interface MBIDAuthenticateResponse {
  accessToken: string;
  refreshToken: string;
  loginToken: string;
  autoStartToken: string;
  _links: {
    subscribe: {
      href: string;
    };
  };
}

export interface MBIDAuthCompleteResponse {
  progressStatus: 'COMPLETE';
  accessToken: string;
  refreshToken: string;
  personRef: string;
  _links: {
    accounts?: {href: string};
    aggregatedAccounts?: {href: string};
    aggregatedMe?: {href: string};
    aggregatedMessages?: {href: string};
    bonusPointsShop?: {href: string};
    cards?: {href: string};
    cbpr?: {href: string};
    chatconfig?: {href: string};
    chatrequest?: {href: string};
    consents?: {href: string};
    contactMe?: {href: string};
    conversations?: {href: string};
    corporateAccounts?: {href: string};
    depositOnboarding?: {href: string};
    documents?: {href: string};
    errands?: {href: string};
    externalPayments?: {href: string};
    faq?: {href: string};
    flexibleTransactions?: {href: string};
    invoices?: {href: string};
    latestTransactions?: {href: string};
    logout?: {href: string};
    me?: {href: string};
    messages?: {href: string};
    myEconomyLogin?: {href: string};
    notifications?: {href: string};
    obaPaymentPreferences?: {href: string};
    obaPaymentProviders?: {href: string};
    offers?: {href: string};
    payees?: {href: string};
    paymentBaskets?: {href: string};
    pinPublicKey?: {href: string};
    preferences?: {href: string};
    pushRegistration?: {href: string};
    readTermsAndConditions?: {href: string; access: 'PUBLIC'};
    refreshToken?: {href: string};
    signTermsAndConditions?: {href: string};
    statements?: {href: string};
    statementsV2?: {href: string};
  };
  _embedded: {notificationInfo: {unread: 0}; messageInfo: {unread: 0}};
}
